package com.ervasstudio.tracoemovimento.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Aluno(
    @SerialName("_ID")
    val id: String, // Usando String porque no JSON está como "1" (com aspas)

    @SerialName("cct_status")
    val status: String? = null,

    @SerialName("nome")
    val nome: String? = null,

    @SerialName("sobrenome")
    val sobrenome: String? = null,

    @SerialName("email")
    val email: String? = null,

    @SerialName("celular")
    val celular: String? = null,

    @SerialName("sexo")
    val sexo: String? = null,

    // Mantendo a chave "nacimento" (com o erro ortográfico original do JSON)
    // mas usando o nome da variável "nascimento" no Kotlin
    @SerialName("nacimento")
    val nascimento: String? = null,

    @SerialName("cct_author_id")
    val id_autor: String? = null,

    @SerialName("cct_created")
    val dataCriacao: String? = null,

    @SerialName("cct_modified")
    val dataModificacao: String? = null,

    @SerialName("cct_slug")
    val slug: String? = null

) {
    
    // Propriedade extra para facilitar a exibição na UI
    val nomeCompleto: String
        get() = "${nome.orEmpty()} ${sobrenome.orEmpty()}".trim()

    // Lógica reaproveitada do seu exemplo para formatar a data
    val nascimentoFormatado: String
        get() {
            if (nascimento.isNullOrBlank()) return ""

            return try {
                // Divide a data "1997-06-06" em ["1997", "06", "06"]
                val partes = nascimento.split("-")
                if (partes.size != 3) return nascimento

                val ano = partes[0]
                val mesNumero = partes[1].toInt()
                val dia = partes[2].toInt() // Remove zeros à esquerda (ex: "06" vira "6")

                val meses = listOf(
                    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
                )

                val mesNome = meses[mesNumero - 1]

                "$dia de $mesNome de $ano"
            } catch (e: Exception) {
                nascimento
            }
        }
}